import { routerStore } from "../state/CommonState"
import { useSnapshot } from "valtio"
import ListRoles from "./list-roles"
import EditRole from "./edit-role"

export default function MainRoles(fn,mode) {
    const store = useSnapshot(routerStore)
    switch(store.rolesCurrentView) {
        case 'list': return <ListRoles/>
        case 'edit': return <EditRole mode='edit'/>
        case 'new': return <EditRole mode='new'/>
        default: return <ListRoles/>
    }
}